import type { IconData } from '@stacksjs/iconify-core'

export const indentIncrease: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M72 63.998h424v32H72zm128 88h296v32H200zm0 88h296v32H200zm0 88h296v32H200zm-128 88h424v32H72zM16 144.909v222.182L171.527 256Zm32 62.182L116.473 256L48 304.909Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default indentIncrease
